var map = {
	"./bitcoin.png": 9903,
	"./bl.png": 9328,
	"./components/EMLOGO.png": 5479,
	"./components/EMLOGO2.png": 9268,
	"./g.png": 6642,
	"./litecoin.png": 7351,
	"./logo.png": 1221,
	"./monero.png": 4211,
	"./zcash.png": 9719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5810;